import { OpenAPI } from "@9amhealth/openapi";
import envVariables from "src/lib/envVariables";

const setupOpenApi = (): void => {
  OpenAPI.BASE = envVariables.API_BASE_URL;
};

export default setupOpenApi;
